// Mimic the functionality of a details, but allow for responsive always showing
if (!customElements.get("countdown-timer")) {
	customElements.define(
		"countdown-timer",
		class DetailsCustom extends HTMLElement {
			constructor() {
				super()
				const timer = this.querySelector("#countdown-timer")

				if (!timer) return

				this.container = this.closest(".countdown-timer")
				this.coundown_timer_interval
				this.initTimer(timer)
			}

			initTimer(timer) {
				//https://stackoverflow.com/questions/56569124/countdown-timer-in-vanilla-javascript-without-using-a-function
				const hourSpan = timer.querySelector(".h")
				const daySpan = timer.querySelector(".d")
				const minSpan = timer.querySelector(".m")
				const secSpan = timer.querySelector(".s")

				const mins = 10
				const now = new Date().getTime()

				const deadline = timer.dataset.deadline //passed through from liquid

				const final_deadline = new Date(parseInt(deadline)).getTime()

				var ms_to_deadline = final_deadline - now

				console.log(`Deadline = ${deadline} final_deadline = ${final_deadline} Now = ${now}  MS To Dead = ${ms_to_deadline}`)

				this.coundown_timer_interval = setInterval(() => {
					//Turn off timer as either deal is over or after
					if (ms_to_deadline >= 0 && final_deadline >= 0) {
						var days = Math.floor(ms_to_deadline / (1000 * 60 * 60 * 24))
						var hours = Math.floor((ms_to_deadline % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
						var minutes = Math.floor((ms_to_deadline % (1000 * 60 * 60)) / (1000 * 60))
						var seconds = Math.floor((ms_to_deadline % (1000 * 60)) / 1000)

						daySpan.innerHTML = days
						hourSpan.innerHTML = hours
						minSpan.innerHTML = minutes
						secSpan.innerHTML = seconds

						timer.classList.add("in-view")

						ms_to_deadline = ms_to_deadline - 1000
					} else {
						this.container.classList.add("hidden")
						window.clearInterval(this.coundown_timer_interval)
					}
				}, 1000)
			}
		}
	)
}
